var installedModules = {};
var moduleToHandlerMapping = {
	77059: {
		getter: function() { return __webpack_require__.e(1933).then(function() { return function() { return __webpack_require__(14041); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	18033: {
		getter: function() { return __webpack_require__.e(3144).then(function() { return function() { return __webpack_require__(43144); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	45400: {
		getter: function() { return __webpack_require__.e(1085).then(function() { return function() { return __webpack_require__(31085); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	69877: {
		getter: function() { return __webpack_require__.e(7768).then(function() { return function() { return __webpack_require__(85387); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.x",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	90359: {
		getter: function() { return __webpack_require__.e(2657).then(function() { return function() { return __webpack_require__(2657); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	542: {
		getter: function() { return __webpack_require__.e(1242).then(function() { return function() { return __webpack_require__(31242); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	58547: {
		getter: function() { return __webpack_require__.e(7128).then(function() { return function() { return __webpack_require__(34747); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	89221: {
		getter: function() { return __webpack_require__.e(4615).then(function() { return function() { return __webpack_require__(66996); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	8287: {
		getter: function() { return __webpack_require__.e(4957).then(function() { return function() { return __webpack_require__(57338); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	33443: {
		getter: function() { return __webpack_require__.e(1513).then(function() { return function() { return __webpack_require__(83894); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	27966: {
		getter: function() { return __webpack_require__.e(6014).then(function() { return function() { return __webpack_require__(6014); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.0.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	86591: {
		getter: function() { return __webpack_require__.e(1543).then(function() { return function() { return __webpack_require__(21543); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.0.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	17256: {
		getter: function() { return __webpack_require__.e(2657).then(function() { return function() { return __webpack_require__(2657); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "12.3.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	17984: {
		getter: function() { return __webpack_require__.e(8656).then(function() { return function() { return __webpack_require__(83894); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "12.3.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	42360: {
		getter: function() { return __webpack_require__.e(2234).then(function() { return function() { return __webpack_require__(66996); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "12.3.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	11326: {
		getter: function() { return __webpack_require__.e(9010).then(function() { return function() { return __webpack_require__(36629); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	67197: {
		getter: function() { return __webpack_require__.e(9010).then(function() { return function() { return __webpack_require__(36629); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "12.3.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	41876: {
		getter: function() { return __webpack_require__.e(3312).then(function() { return function() { return __webpack_require__(40931); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/server",
	}
};
var initialConsumes = [77059,18033,45400,69877,17256,17984,542,42360,11326,67197,17984,542,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,17256,17984,542,42360,11326,67197,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17256,17984,542,42360,11326,67197,542,17984,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,42360,542,17984,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,17256,542,42360,11326,67197,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,42360,542,17984,11326,67197,17256,17984,542,42360,11326,67197,17256,41876,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,42360,542,17984,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,542,67197,11326,17984,42360,17256,542,67197,11326,17984,42360,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17256,542,67197,17984,42360,11326,542,17984,42360,11326,67197,17256,17256,542,67197,17984,42360,11326,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17256,17984,542,42360,11326,67197,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,542,17984,42360,11326,67197,17256,67197,17984,542,42360,11326,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17256,17984,542,42360,11326,67197,542,17984,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256,17984,542,42360,11326,67197,17256];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"77": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"110": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"112": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"149": [
		542,
		67197,
		11326,
		17984,
		42360,
		17256
	],
	"194": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"203": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"282": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"315": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"329": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"337": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"455": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"543": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"545": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"576": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"621": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"636": [
		45400,
		69877
	],
	"777": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"809": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"931": [
		77059
	],
	"1281": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"1290": [
		17256,
		17984,
		542,
		42360,
		11326,
		67197
	],
	"1633": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"1635": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"1657": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"1728": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"1906": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"1992": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"2034": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"2054": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"2216": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"2416": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"2424": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"2448": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"2474": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"2491": [
		42360,
		542,
		17984,
		11326,
		67197,
		17256
	],
	"2508": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"2731": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"2754": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"2977": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"3099": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"3247": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"3267": [
		67197,
		17984,
		542,
		42360,
		11326,
		17256
	],
	"3332": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"3389": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"3454": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"3466": [
		77059
	],
	"3537": [
		17256,
		17984,
		542,
		42360,
		11326,
		67197
	],
	"3566": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"3608": [
		42360,
		542,
		17984,
		11326,
		67197,
		17256
	],
	"3626": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"3633": [
		77059
	],
	"3694": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"3697": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"3894": [
		77059
	],
	"3924": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"3988": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"4076": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"4226": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256,
		41876
	],
	"4586": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"4590": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"4592": [
		17256,
		17984,
		542,
		42360,
		11326,
		67197
	],
	"4734": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"4747": [
		77059
	],
	"4895": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"4956": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"5038": [
		77059
	],
	"5120": [
		90359,
		542,
		58547,
		89221,
		8287,
		33443,
		77059,
		27966,
		86591,
		45400
	],
	"5286": [
		77059
	],
	"5304": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"5387": [
		77059
	],
	"5410": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"5451": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"5561": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"5567": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"5762": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"5774": [
		42360,
		542,
		17984,
		11326,
		67197,
		17256
	],
	"5797": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"5807": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"6042": [
		17256,
		17984,
		542,
		42360,
		11326,
		67197
	],
	"6137": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"6147": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"6349": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"6485": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"6588": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"6629": [
		45400,
		77059
	],
	"6672": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"6781": [
		77059
	],
	"6996": [
		77059
	],
	"7014": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"7051": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"7123": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"7138": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"7185": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"7194": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"7290": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"7296": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"7338": [
		77059
	],
	"7382": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"7512": [
		17256,
		542,
		67197,
		17984,
		42360,
		11326
	],
	"7549": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"7782": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"7804": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"7813": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"8024": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"8116": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"8156": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"8165": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"8406": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"8484": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"8562": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"8588": [
		542,
		67197,
		11326,
		17984,
		42360,
		17256
	],
	"8695": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"8735": [
		17256,
		542,
		67197,
		17984,
		42360,
		11326
	],
	"8747": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"8754": [
		17984,
		17256,
		542,
		42360,
		11326,
		67197
	],
	"8792": [
		77059,
		18033
	],
	"8884": [
		77059
	],
	"8995": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"9031": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"9099": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"9164": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"9314": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"9378": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"9420": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"9566": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"9621": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"9695": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"9721": [
		17256,
		17984,
		542,
		42360,
		11326,
		67197
	],
	"9794": [
		542,
		17984,
		42360,
		11326,
		67197,
		17256
	],
	"9851": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"9876": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	],
	"9911": [
		17984,
		542,
		42360,
		11326,
		67197,
		17256
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}